import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useParams } from 'react-router-dom';
import { ModifyOrganizationInput } from 'types/Organization';
import queryOrgEditableFields from 'api/Organization/queryOrgEditableFields';
import updateOrganization from 'api/Organization/updateOrganization';

export default function useUpdateOrganization() {
    const client = useClient();
    const params = useParams<{ uri: string }>();
    const { openAlert } = useAlert();
    const [updating, setUpdating] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [error, setError] = useState(false);
    const [organization, setOrganization] = useState<ModifyOrganizationInput>({
        description: '',
        SamlGroupName: '',
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (params.uri) {
                    setContentLoading(true);
                    const response = await client.query(
                        queryOrgEditableFields(params.uri),
                    );
                    if (!response.errors) {
                        setOrganization(response.data.getOrganization);
                    } else {
                        setError(true);
                        openAlert({
                            message: `Could not retrieve organization, received ${response.errors[0]?.message}`,
                            severity: 'alert',
                        });
                    }
                }
            } finally {
                setContentLoading(false);
            }
        };

        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    const handleSubmit = async (formData: ModifyOrganizationInput) => {
        setUpdating(true);
        try {
            if (params.uri) {
                const response = await client.mutate(
                    updateOrganization(params.uri, formData),
                );

                if (!response.errors) {
                    openAlert({
                        message: `Succesfully updated organization`,
                        severity: 'success',
                    });
                } else {
                    openAlert({
                        message: `Could not udpate organization, received ${response.errors[0]?.message}`,
                        severity: 'alert',
                    });
                }
            }
        } finally {
            setUpdating(false);
        }
    };

    return {
        organization,
        contentLoading,
        error,
        handleSubmit,
        updating,
    };
}
